import { Injectable } from '@angular/core';
import { BaseApiService } from '@max/shared/base-service/base-api.service';
import { OutOfJurisdictionRegistrationModel } from '../models/out-of-jurisdiction-registration.model';

@Injectable()
export class CommercialOutOfJurisdictionRegistrationService extends BaseApiService {
    public getActiveOutOfJurisdictionRegistration = (vehicleId: number) => this.get(`commercialpermitting/OutOfStateRegistration/Registration/${vehicleId}/Active`);

    public getOutOfJurisdictionRegistrations = (vehicleId: number) => this.get(`commercialpermitting/OutOfStateRegistration/Registration/${vehicleId}/History`);

    public saveOutOfJurisdictionRegistration = (model: OutOfJurisdictionRegistrationModel) => this.post('commercialpermitting/OutOfStateRegistration/Save', model);

}
